import {
    ArrayField,
    ArrayFieldProps,
    Datagrid,
    NumberField,
    TextField,
    SingleFieldList,
    useRecordContext
  } from 'react-admin';
  import { Grid, Box, Typography, Stack, BoxProps } from '@mui/material';
import { PriceField } from '../components/PriceField';

  export const TaxSummary = (props: Omit<ArrayFieldProps, 'children'>) => {
    const record = useRecordContext();
    
    // Check if the taxes field exists and is an array
    const taxesData = record?.[props.source as string];
    const hasTaxes = Array.isArray(taxesData) && taxesData.length > 0;
    
    return (
        <Box m={2}>
            <Stack direction="row" justifyContent="end">
            <Stack direction="column" justifyContent="right">
            {hasTaxes && (
              <ArrayField {...props}>
                  <SingleFieldList linkType={false} sx={{
                      flexDirection: 'column'
                  }}>
                      <TotalItem sx={{fontSize: '14px'}}>
                      <span>Tax @ <NumberField source="TaxLineDetail.TaxPercent" />%
                      on <NumberField source="TaxLineDetail.NetAmountTaxable" />{`: `}
                      <NumberField source="Amount" options={{ style: 'currency', currency: 'CAD' }}/>
                      </span>
                      </TotalItem>
                      </SingleFieldList>
              </ArrayField>
            )}
                  <TotalItem>
                    <PriceField source="total_amount" label="Total" sx={{fontSize: '14px', color: '#404452', marginTop: '8px'}}/>
                  </TotalItem>
                  </Stack>
            </Stack>
        </Box>
      );
  };
  

  function TotalItem(props: BoxProps) {
    const { sx, ...other } = props;
    return (
      <Box
        sx={{
          p: 1,
          mr: 1,
          color: (theme) => (theme.palette.mode === 'dark' ? 'grey.300' : '#424242'),
          fontWeight: '400',
          ...sx,
        }}
        {...other}
      />
    );
  }